import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth, STAFF_ROLES } from "@/context/AuthContext";

export function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen bg-obsidian flex items-center justify-center" data-testid="auth-loading">
        <div className="h-10 w-10 border-4 border-steel border-t-lomond rounded-full animate-spin" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children || <Outlet />;
}

export function RequireStaff({ children }) {
  const { user } = useAuth();
  if (user && !STAFF_ROLES.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children || <Outlet />;
}

export function RequireManagement({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "management_admin") {
    return <Navigate to="/staff" replace />;
  }
  return children;
}
